// extracted by mini-css-extract-plugin
module.exports = {"root":"selection-card_root__OxywB","checked":"selection-card_checked__X9QvC","disabled":"selection-card_disabled__N5B_5"};